import { useContext, useState, useEffect } from "react";
import { HashLink } from "react-router-hash-link";

import Wave from "react-wavify";
import { storeContext } from "./global/store";
import OpeningAnimatedLayer from "./components/OpeningAnimatedLayer";
import ClosingAnimatedLayer from "./components/ClosingAnimatedLayer";
import Footer from "./components/blockLayout/Footer";

const Experiences = () => {
  const { store } = useContext(storeContext);
  const [showLayer, setShowLayer] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setShowLayer(false);
    }, 1800);
  }, []);

  return (
    <div className="">
      <div className="gridAreaOne grid">
        <div className="gridAreaOne">
          <div className="max-w-[1024px] mx-auto px-4">
            <div className="pt-8 md:py-8 space-y-8 flex flex-col-reverse md:flex-row items-center justify-between">
              <h1 className="text-center text-primary-color font-semibold text-4xl mt-6 md:mt-10">
                Experiences <span>🛠</span>
              </h1>
              <HashLink
                to="/"
                className="text-sm underline font-normal leading-loose opacity-60 text-center space-x-1"
              >
                <span>Home</span>
              </HashLink>
            </div>
          </div>
          <Wave
            className="relative top-2"
            fill="#f2f2f2"
            paused={false}
            options={{
              height: 30,
              amplitude: 30,
              speed: 0.3,
              points: 10,
            }}
          />
          <div className="bg-[#f2f2f2]">
            <section className="mx-auto flex flex-col items-center justify-between space-y-6 px-4 pt-10 pb-10 lg:max-w-[1024px] lg:flex-row lg:space-y-0">
              <div className="flex w-11/12 flex-col items-center justify-center space-x-2 lg:w-full">
                <Wolt />
                <Mindera />
                <RiverDone />
                <NuTerraLabs />
                <Smartinia />
                <Fasty />
              </div>
            </section>
          </div>
          <Wave
            className="rotate-180 relative bottom-2"
            fill="#f2f2f2"
            paused={false}
            options={{
              height: 30,
              amplitude: 30,
              speed: 0.3,
              points: 10,
            }}
          />
          <Footer />
        </div>
        {showLayer && <ClosingAnimatedLayer></ClosingAnimatedLayer>}
      </div>
      {store.triggerAnimation && <OpeningAnimatedLayer></OpeningAnimatedLayer>}
    </div>
  );
};

const Wolt = () => {
  return (
    <section id="exp-wolt" className="w-full space-y-12 text-left">
      <div className="text-left space-y-2">
        <h1 className="text-[#000] font-semibold text-xl md:text-2xl ">Wolt</h1>
        <h1 className="text-primary-color font-semibold text-md md:text-lg ">
          JUNE 2026 - TO NOW
        </h1>
      </div>
      <div className="flex w-full flex-row items-center justify-between space-x-0 px-1">
        <div className="flex flex-col items-start justify-between space-y-3">
          <p className="text-sm font-normal leading-loose opacity-90">
            Part of the Courier Fleet team, working on DeliveryOS, a platform
            for managing fleet companies and couriers.
          </p>
          <br />
          <p className="text-sm font-normal leading-loose opacity-90">
            - Building and improving scalable features using TypeScript.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Collaborating with product, design, and various teams to deliver
            reliable fleet management solutions.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Contributing to overall architecture, code quality, testing, and
            engineering best practices.
          </p>
        </div>
      </div>
    </section>
  );
};

const Mindera = () => {
  return (
    <section id="exp-mindera" className="mt-48 w-full space-y-12 text-left">
      <div className="text-left space-y-2">
        <h1 className="text-[#000] font-semibold text-xl md:text-2xl ">
          MINDERA
        </h1>
        <h1 className="text-primary-color font-semibold text-md md:text-lg ">
          NOVEMBER 2022 - JUNE 2026
        </h1>
      </div>
      <div className="flex w-full flex-row items-center justify-between space-x-0 px-1">
        <div className="flex flex-col items-start justify-between space-y-3">
          <p className="text-sm font-normal leading-loose opacity-90">
            Mindera partners with global clients to build large-scale digital
            products across sectors like telecommunications, retail and IoT.
          </p>
          <br />
          <p className="text-sm font-normal leading-loose opacity-90">
            Client: Vodafone
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            Product: Subscription+
          </p>
          <br />
          <p className="text-sm font-normal leading-loose opacity-90">
            - I led the frontend team modernizing Vodafone Subscription+, a
            customer rewards platform offering discounted subscriptions from
            entertainment partners like Netflix, Spotify, and HBO.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Migrated the legacy React codebase (class components) to modern
            React with Hooks and TypeScript, improving maintainability,
            scalability and performance.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Architected a new frontend structure with optimized JavaScript
            bundles, Efficient code splitting & lazy loading, CI/CD pipelines
            and comprehensive unit testing.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Implemented and maintained a robust internationalization (i18n)
            system, supporting regional configurations, localized content, and
            dynamic partner offers per country.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Collaborated closely with Product Owners and UI/UX Designers to
            transform requirements into polished, user-friendly frontend
            experiences.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Worked hand-in-hand with Backend Engineers and Solution Architects
            to design efficient API integrations and consistent data exchange
            flows.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Mentored and guided junior frontend developers through code
            reviews, architectural discussions, and best practices.
          </p>
          <br />
          <p className="text-sm font-normal leading-loose opacity-90">
            Client: Vocovo
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            Product: IoT Dashboard Platform & PWA enrollment app
          </p>
          <br />
          <p className="text-sm font-normal leading-loose opacity-90">
            - I contributed to the development and maintenance of a real-time
            IoT dashboard overseeing thousands of in-store hardware devices.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Implemented complex features such as message broadcasting and
            audio casting from the dashboard to store headsets.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Modernized an outdated JavaScript codebase to TypeScript & React
            Hooks, reducing bugs and improving scalability and maintainability.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Developed a frontend design system and component documentation
            using Storybook, ensuring visual consistency and faster UI
            development.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Developed a React PWA enrollment app for on-site user registration
            with features such as offline mode, automatic data synchronization
            and device pairing.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Wrote and maintained end-to-end tests using Playwright and
            Cypress, improving regression coverage and ensuring stability of
            critical user flows.
          </p>
        </div>
      </div>
    </section>
  );
};

const RiverDone = () => {
  return (
    <section id="exp-riverdone" className="mt-48 w-full space-y-12 text-left">
      <div className="text-left space-y-2">
        <h1 className="text-[#000] font-semibold text-xl md:text-2xl ">
          RIVER-DONE DIGITAL
        </h1>
        <h1 className="text-primary-color font-semibold text-md md:text-lg ">
          MAY 2022 - NOVEMBER 2022
        </h1>
      </div>
      <div className="flex w-full flex-row items-center justify-between space-x-0 px-1">
        <div className="flex flex-col items-start justify-between space-y-3">
          <p className="text-sm font-normal leading-loose opacity-90">
            RiverDone Digital delivers custom digital products for clients in
            Web3, fintech, and SaaS industries.
          </p>
          <br />
          <p className="text-sm font-normal leading-loose opacity-90">
            Finimize Referral Feature:
          </p>
          <br />
          <p className="text-sm font-normal leading-loose opacity-90">
            - I took technical ownership of the frontend implementation of a new
            referral feature for Finimize, enhancing user acquisition and
            engagement.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Contributed to both mobile (React Native) and web (Next.js)
            product platforms.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Created visually consistent, responsive HTML/CSS email templates
            for referral notifications and campaigns.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Improved the CI/CD pipeline effectiveness & performance.
          </p>
          <br />
          <p className="text-sm font-normal leading-loose opacity-90">
            Mobile Blockchain App:
          </p>
          <br />
          <p className="text-sm font-normal leading-loose opacity-90">
            - I worked on React Native blockchain fitness app rewarding users
            with NFTs based on physical activity (steps, runs).
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Integrated native mobile APIs for step tracking and real-time
            rewards synchronization.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Collaborated with backend engineers to ensure seamless blockchain
            data flow and user wallet interactions.
          </p>
        </div>
      </div>
    </section>
  );
};

const NuTerraLabs = () => {
  return (
    <section id="exp-nuterralabs" className="mt-48 w-full space-y-12 text-left">
      <div className="text-left space-y-2">
        <h1 className="text-[#000] font-semibold text-xl md:text-2xl ">
          NU TERRA LABS
        </h1>
        <h1 className="text-primary-color font-semibold text-md md:text-lg ">
          FEBRUARY 2022 - MAY 2022
        </h1>
      </div>
      <div className="flex w-full flex-row items-center justify-between space-x-0 px-1">
        <div className="flex flex-col items-start justify-between space-y-3">
          <p className="text-sm font-normal leading-loose opacity-90">
            Nu Terra Labs provides digital marketing and technology solutions in
            the agriculture sector.
          </p>
          <br />
          <p className="text-sm font-normal leading-loose opacity-90">
            - I migrated the existing single-page React application to Next.js
            with server-side rendering, significantly improving SEO performance,
            load times and indexing.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Optimized overall site performance and accessibility, leading to
            better engagement and organic visibility.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Introduced a QA process and internal developer workflow guide to
            standardize development practices.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Enforced a consistent coding style and documentation standards
            across the frontend team.
          </p>
        </div>
      </div>
    </section>
  );
};

const Smartinia = () => {
  return (
    <section id="exp-smartinia" className="mt-48 w-full space-y-12 text-left">
      <div className="text-left space-y-2">
        <h1 className="text-[#000] font-semibold text-xl md:text-2xl ">
          SMARTINIA
        </h1>
        <h1 className="text-primary-color font-semibold text-md md:text-lg ">
          FEBRUARY 2021 - FEBRUARY 2022
        </h1>
      </div>
      <div className="flex w-full flex-row items-center justify-between space-x-0 px-1">
        <div className="flex flex-col items-start justify-between space-y-3">
          <p className="text-sm font-normal leading-loose opacity-90">
            Smartinia builds SaaS products in e-commerce, e-learning, and
            logistics.
          </p>
          <br />
          <p className="text-sm font-normal leading-loose opacity-90">
            E-Commerce Platform:
          </p>
          <br />
          <p className="text-sm font-normal leading-loose opacity-90">
            - I developed product pages, basket, checkout, and payment features
            with seamless UX.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Improved page load times and UI responsiveness across devices.
          </p>
          <br />
          <p className="text-sm font-normal leading-loose opacity-90">
            E-Learning Platform:
          </p>
          <br />
          <p className="text-sm font-normal leading-loose opacity-90">
            - I built online courses frontend application with video player
            functionality, comment and reaction systems, and interactive user
            dashboards.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Focused on accessibility, modern design, and responsive layout.
          </p>
          <br />
          <p className="text-sm font-normal leading-loose opacity-90">
            Mobile Parcel Delivery App:
          </p>
          <br />
          <p className="text-sm font-normal leading-loose opacity-90">
            - I implemented user profile management, real-time chat messaging,
            and push notifications using WebSockets.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Enhanced reliability of real-time communication and notifications.
          </p>
        </div>
      </div>
    </section>
  );
};

const Fasty = () => {
  return (
    <section id="exp-fasty" className="mt-48 w-full space-y-12 text-left">
      <div className="text-left space-y-2">
        <h1 className="text-[#000] font-semibold text-xl md:text-2xl ">
          FASTY DELIVERY
        </h1>
        <h1 className="text-primary-color font-semibold text-md md:text-lg ">
          AUGUST 2019 - AUGUST 2020
        </h1>
      </div>
      <div className="flex w-full flex-row items-center justify-between space-x-0 px-1">
        <div className="flex flex-col items-start justify-between space-y-3">
          <p className="text-sm font-normal leading-loose opacity-90">
            Fasty is a food delivery platform connecting local restaurants with
            customers.
          </p>
          <br />
          <p className="text-sm font-normal leading-loose opacity-90">
            - I built an administrative web application to simplify and
            accelerate menu and restaurant data entry.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            - Automated data collection and transformation workflows using
            Node.js and Python scripts, reducing manual input time.
          </p>
          <p className="text-sm font-normal leading-loose opacity-90">
            -Designed and optimized complex SQL queries to support analytics and
            improve backend efficiency.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Experiences;
